module.exports = __webpack_public_path__ + "img/arw-left.86d7494e.svg";